import { render } from "./MezzoDettaglio.vue?vue&type=template&id=12f4a010&scoped=true"
import script from "./MezzoDettaglio.vue?vue&type=script&lang=js"
export * from "./MezzoDettaglio.vue?vue&type=script&lang=js"

import "./MezzoDettaglio.vue?vue&type=style&index=0&id=12f4a010&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f4a010"]])

export default __exports__